/*
 * /patient (list page)
 */
import {
	Button,
	Card,
	CardContent,
	Container,
	Input,
	Page,
	PageHeader,
	Placeholder,
} from "@emr/react-ui"
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router"
import { ChevronRight, Plus, User } from "lucide-react"
import { useState } from "react"
import { trpc } from "../../trpc"

export const Route = createFileRoute("/patient/")({
	component: PatientListPage,
})

function PatientListPage() {
	const navigate = useNavigate()
	const [search, setSearch] = useState("")

	const { data: patients, isLoading } = trpc.patient.getAllByFilter.useQuery({
		where: { active: true },
	})

	const filtered = patients?.filter((p) => {
		const q = search.toLowerCase()
		if (!q) return true
		return (
			p.firstName.toLowerCase().includes(q) ||
			p.lastName.toLowerCase().includes(q)
		)
	})

	return (
		<Page>
			<Container width="xl" padding="lg" gap="lg">
				<PageHeader
					title="Patients"
					right={{
						Component: (
							<Button onClick={() => navigate({ to: "/patient/new" })}>
								<Plus className="w-4 h-4 mr-1" />
								New Patient
							</Button>
						),
					}}
				/>

				<Input
					placeholder="Search by name..."
					value={search}
					onChange={(e) => setSearch(e.target.value)}
					className="max-w-sm"
				/>

				{isLoading ? (
					<Placeholder title="Loading..." />
				) : !filtered || filtered.length === 0 ? (
					<Placeholder title={search ? "No patients match your search." : "No patients yet."} />
				) : (
					<div className="flex flex-col gap-3">
						{filtered.map((patient) => (
							<Link
								key={patient.id}
								to="/patient/$patientId"
								params={{ patientId: patient.id }}
								className="block"
							>
								<Card className="hover:bg-accent/50 transition-colors cursor-pointer">
									<CardContent className="flex items-center justify-between py-4">
										<div className="flex items-center gap-3">
											<User className="w-5 h-5 text-muted-foreground shrink-0" />
											<div>
												<p className="font-medium">
													{patient.firstName} {patient.lastName}
												</p>
												{patient.dateOfBirth && (
													<p className="text-sm text-muted-foreground">
														DOB:{" "}
														{new Date(patient.dateOfBirth).toLocaleDateString(
															"en-CA",
															{ year: "numeric", month: "short", day: "numeric" },
														)}
													</p>
												)}
											</div>
										</div>
										<ChevronRight className="w-4 h-4 text-muted-foreground" />
									</CardContent>
								</Card>
							</Link>
						))}
					</div>
				)}
			</Container>
		</Page>
	)
}
